import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Filter } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const FilterNode = ({ data, selected }: NodeProps) => {
    // Build a human-readable summary of configured conditions
    const getFilterSummary = () => {
        // Custom SQL condition (manual mode)
        if (data.isManualCondition && data.condition) {
            return data.condition.length > 30 ? data.condition.slice(0, 30) + '…' : data.condition;
        }
        // Basic/structured conditions array
        if (data.conditions && data.conditions.length > 0) {
            const logic = data.logic || 'AND';
            const parts = data.conditions
                .filter((c: any) => c.column)
                .map((c: any) => {
                    const op = c.operator || '=';
                    const isNullOp = ['IS NULL', 'IS NOT NULL', 'is null', 'is not null'].includes(op);
                    return isNullOp ? `${c.column} ${op}` : `${c.column} ${op} ${c.value ?? ''}`;
                });
            if (parts.length === 0) return 'All Rows';
            const summary = parts.join(` ${logic} `);
            return summary.length > 35 ? summary.slice(0, 35) + '…' : summary;
        }
        // Legacy single-field fallback
        return data.condition || 'All Rows';
    };

    return (
        <BaseNodeUI
            title={data.label || "Filter"}
            icon={Filter}
            colorClass=""
            bgClass="bg-gradient-to-br from-blue-500 to-blue-700"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
        >
            {getFilterSummary()}
        </BaseNodeUI>
    );
};

export default memo(FilterNode);
